import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { Observable } from 'rxjs';
import { LicenseType } from '../enums/license-type';
import { HttpClientUtils } from '../studio-http-client/http-client-utils';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  private apiService: ApiService = inject(ApiService);

  public getLicenseByUserId(userId: number, licenseType: LicenseType[]): Observable<LicenseType[]> {
    const url = `v1/internal/users/${userId}/GetLicenses`;
    const queryParams = HttpClientUtils.createURLSearchParams({
      licenseType,
    });

    return this.apiService.invokeMPApi(url + queryParams, HttpAction.Get);
  }
}
